// https://app.growthbook.io/features/mccerts-2624_v1
export const MCCERTS_2624_HUB_SUBS_ROW_FLAG = 'mccerts-2624_v1'

export type HubSubsRowBucket = 'control' | 'variant_1'
